import React from 'react'

const Button = (props) => {
  const { type, title, ariaControls, onClick, disabled } = props
  return (
    <button
      className="btn e-btn"
      type={type || 'button'}
      onClick={onClick}
      aria-controls={ariaControls}
      disabled={false || disabled}
    >
      {title}
    </button>
  )
}

export default Button